import React, { HTMLAttributes } from 'react';

import {
  SvgIconNames,
  SvgIconsMap,
} from '~/design-tokens/iconography/SvgIcons';

export interface IconProps extends HTMLAttributes<SVGSVGElement> {
  iconName: SvgIconNames;
  className?: string;
  size?: number;
  width?: number;
  height?: number;
  viewBox?: string;
  fillColor?: string;
  strokeColor?: string;
}

export const Icon = ({
  iconName,
  className,
  size = 40,
  width,
  height,
  viewBox = '0 0 40 40',
  fillColor = 'var(--icon-default)',
  strokeColor,
  ...rest
}: IconProps) => {
  const SVGIcon = SvgIconsMap[iconName];
  return (
    <>
      {SVGIcon ? (
        <SVGIcon
          width={width ?? size}
          height={height ?? size}
          viewBox={viewBox}
          fill={fillColor}
          stroke={strokeColor}
          className={className}
          data-testid={`${iconName}-icon`}
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        />
      ) : null}
    </>
  );
};
